import { render } from "./cv.vue?vue&type=template&id=642c491a"
import script from "./cv.vue?vue&type=script&lang=js"
export * from "./cv.vue?vue&type=script&lang=js"

import exportComponent from "/home/apps/ru_dklimanov/production/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__